import { useState, useEffect } from 'react'
import { seleteIncomeCertificateAPI } from '../services/income/certficate'

function UseAllCertificate() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const resp = await seleteIncomeCertificateAPI()
      if (!resp) return
      if (resp.status) {
        const newData = resp.result.map((d, i) => {
          return { ...d, value: d?.paymentNameCerId, label: d?.paymentNameCer }
        })
        setData(newData)
      } else {
        setData([])
      }
    }
    getData()
  }, [])
  return data
}

export default UseAllCertificate
